import React from 'react';
import { Alert, Collapse } from 'reactstrap';

import Icon, { faCheckCircle, faInfoCircle, faTriangleExclamation } from '~components/icon';

import { InputProps } from '../props';

interface ComponentProps extends InputProps {
  color: string;
}

const AlertMessage: React.FC<ComponentProps> = ({ id, color = 'info', value }) => {
  let icon;
  switch (color) {
    case 'info':
    default: {
      icon = faInfoCircle;
      break;
    }
    case 'success': {
      icon = faCheckCircle;
      break;
    }
    case 'danger':
    case 'warning': {
      icon = faTriangleExclamation;
      break;
    }
  }

  const isOpen = value !== undefined && value !== null && value?.length > 0;

  return (
    <Collapse isOpen={isOpen}>
      <Alert
        color={color}
        className="d-flex align-items-center justify-content-center"
        data-cy={`${id}-alert`}
        fade={false}
      >
        <Icon className="me-3" size="2x" icon={icon} />
        <div className="fw-bold">{value}</div>
      </Alert>
    </Collapse>
  );
};

export default AlertMessage;
